import { flip } from "./lib/animation";
import PlaylistState from "./lib/playlist-store.js";
import { clone } from "./lib/utils.js";

function playlistBuilder() {
  return {
    init() {
      this.store = PlaylistState.fromLocalStorage();
      this.name = clone(this.store.name);
      this.datasets = clone(this.store.datasets);

      this.$watch("name", this.save.bind(this));
      this.store.subscribe(this.onStoreChange.bind(this));
    },

    name: "custom_playlist",
    datasets: [],

    get fileName() {
      return this.name
        ? this.name + (this.name.endsWith(".sos") ? "" : ".sos")
        : "custom_playlist.sos";
    },

    get playlistUrl() {
      var now = new Date();

      // Match non-ASCII characters so we can URL encode them to avoid problems
      // when we base64 encode the playlist file.
      var nonASCII = /[^\x00-\x7F]/g; // eslint-disable-line no-control-regex

      var playlist = "# Created by SOS Playlist Builder\n";
      playlist +=
        "# Saved: " +
        now.toLocaleString("en", { dateStyle: "medium", timeStyle: "long" }) +
        "\n";
      playlist += "# Contains " + this.datasets.length + " dataset";
      if (this.datasets.length !== 1) playlist += "s";

      this.datasets.forEach(function (d) {
        var variation = d.variations[d.selectedVariation];
        playlist +=
          "\n\n# ID " +
          d.id +
          ": " +
          variation.name.replace(nonASCII, function (tok) {
            // URI encode any non-ASCII characters in the name. btoa will throw
            // an error if it encounters a character outside of the Latin1
            // character set.
            return encodeURIComponent(tok);
          }) +
          "\n";
        playlist += "include = " + variation.playlistPath;
      });

      return "data:text/plain;base64," + window.btoa(playlist);
    },

    remove(idx) {
      this.store.removeDataset(idx);
    },

    reset() {
      var result = window.confirm(
        "Remove all datasets from your playlist and reset the playlist name?"
      );
      if (result) this.store.resetPlaylist();
    },

    save() {
      console.log("save()", this.name);
      this.store.update({ name: this.name, datasets: this.datasets });
    },

    onStoreChange(state) {
      var positions = {};
      var rows = document.querySelectorAll(".sos-dataset");
      var n = rows.length,
        i;

      for (i = 0; i < n; i++) {
        positions[rows[i].getAttribute("id")] = rows[i].getBoundingClientRect();
      }

      this.$nextTick(
        flip(positions, function () {
          return document.querySelectorAll(".sos-dataset");
        })
      );

      this.name = clone(state.name);
      this.datasets = clone(state.datasets);
    },
  };
}

window.playlistBuilder = playlistBuilder;
